import { render } from "./CardProfile.vue?vue&type=template&id=b6fc3d60"
import script from "./CardProfile.vue?vue&type=script&lang=js"
export * from "./CardProfile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__